import {DataGridPro} from '@mui/x-data-grid-pro'
import {customerActivityColumns} from 'pages/customer/dataConfig/declearColumns'
import {customerActivityFilter} from 'pages/customer/dataConfig/declearFilters'
import {CustomerActivityGroup} from 'pages/customer/dataConfig/declearGroupingModel'
import {customerActivityRows} from 'pages/customer/dataConfig/declearRows'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {getMonitoringList} from 'utils/apiCalling/api'
import MeterariumPageLayout from 'utils/designSytem/MeterariumPageLayout'
import {scrollTop} from 'utils/func/justUtils'
import {toolTipText} from 'utils/toolTips/toolTipText'

const CustomerActivity = (props: any) => {
  /*********************************************************************
   * 1. Init Libs
   *********************************************************************/
  const officeInfo = useSelector((state: any) => state.officeInfo)
  const cooperInfo = useSelector((state: any) => state.cooperInfo)
  /*********************************************************************
   * 2. State settings
   *********************************************************************/
  const [pageSize, setPageSize] = useState<number>(30)
  const [loading, setLoading] = useState<boolean>(false)
  const [filter, setFilter] = useState<any>(customerActivityFilter)
  const [monitoringList, setMonitoringList] = useState<any>([])
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false)
  /*********************************************************************
   * 3. Handlers
   *********************************************************************/
  const getMonitoringListCall = () => {
    const checkBusan = String(officeInfo.value).slice(0, 2) === '13'
    const hasAnyTrue = Object.values(filter.searchOption ?? {}).some((v) => v === true)
    const newSearchOption =
      !filter.searchOption?.customerNumber && hasAnyTrue
        ? {installer: false}
        : {customerNumber: true}
    let selectedFilter = filter
    if (checkBusan) {
      selectedFilter = {
        ...filter,
        searchOption: newSearchOption,
        // searchOption: {
        // customerNumber:
        //   !filter.searchOption.customerNumber && !filter.searchOption.managerName
        //     ? true
        //     : filter.searchOption.customerNumber,
        // managerName:
        //   !filter.searchOption.customerNumber && !filter.searchOption.managerName
        //     ? true
        //     : filter.searchOption.managerName,
        // },
      }
    }

    getMonitoringList(officeInfo, cooperInfo, selectedFilter, {
      success: (res: any) => {
        setMonitoringList(res)
        setLoading(false)
      },
      fail: (err: any) => {
        setLoading(false)
      },
      loading: (loading: boolean) => {
        setLoading(loading)
      },
    })
  }
  const columns: any = customerActivityColumns(filter)

  const rows = customerActivityRows(monitoringList)

  //기능 보류
  const busanSearchHandler = (officeId: any) => {
    const checkBusan = String(officeId).slice(0, 2) === '13'
    // if (checkBusan) {
    //   return ['customerNumber', 'managerName']
    // } else {
    return ['customerNumber', 'customerName', 'address', 'managerName', 'memo']
    // }
  }

  /*********************************************************************
   * 4. UseEffect
   *********************************************************************/
  useEffect(() => {
    getMonitoringListCall()
  }, [officeInfo, cooperInfo])
  useEffect(() => {
    scrollTop()
    getMonitoringListCall()
  }, [filter.date])
  /*********************************************************************
   * 5. Page configuration
   *********************************************************************/

  return (
    <>
      <MeterariumPageLayout
        headerDescription={toolTipText.customerActivity.description}
        tooltipText={toolTipText.customerActivity.text}
        hideSearchOptions={accordionOpen}
        setHideSearchOptions={setAccordionOpen}
        filter={filter}
        id={'customer-activity'}
        setFilter={setFilter}
        searchCallback={getMonitoringListCall}
        total={rows.length}
        control={['selectDate']}
        actions={[]}
        searchOptions={busanSearchHandler(officeInfo.value)}
        checkData={null}
        onDelete={null}
        onCancel={null}
        setTypeName={null}
      >
        <DataGridPro
          headerHeight={30}
          rowHeight={210}
          autoHeight={true}
          columnGroupingModel={CustomerActivityGroup}
          experimentalFeatures={{columnGrouping: true}}
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[10, 30, 50, 70, 100]}
          disableColumnMenu
          pagination
          loading={loading}
          sx={{
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',
            },
          }}
        />
      </MeterariumPageLayout>
    </>
  )
}
export default CustomerActivity
